import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../../Redux/hooks";

const AdminUrlSetter = () => {
  let [, setSearchParams] = useSearchParams();
  const { searchText, type, page, sortOrder, sortColumn } = useAppSelector(
    (state) => state.administrators
  );

  useEffect(() => {
    const params = new URLSearchParams();
    params.set("page", page.toString());
    if (searchText) {
      params.set("search", searchText);
    }
    if (sortOrder) {
      params.set("order", sortOrder);
    }
    if (sortColumn) {
      params.set("sort", sortColumn);
    }
    if (type) {
      params.set("type", type);
    }
    setSearchParams(params, {
      replace: true,
    });
  }, [setSearchParams, searchText, type, page, sortOrder, sortColumn]);

  return <></>;
};

export default AdminUrlSetter;
